import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";

const Navbar = ({ isReferral }) => {
  const [toggle, setToggle] = useState(false);
  const { user, token, otpForgetePassword } = useSelector(
    (state) => state.customReducer,
  );

  const navLinkStyles = ({ isActive }) => {
    return {
      fontWeight: isActive ? "bold" : "normal",
      borderBottom: isActive ? "2px solid #fff" : "0",
    };
  };

  return (
    <nav className="fixed left-0 right-0 top-0 z-10 w-full bg-[#231C42] px-[2%]">
      <div className="mx-auto flex h-[80px] max-w-[1440px] items-center justify-between px-[16px] md:px-0">
        <div className="flex items-center justify-start">
          <div>
            <Link
              onClick={() => {
                setToggle(false);
              }}
              to="/"
            >
              <img
                className="w-full max-w-[144px]"
                src="/images/logo.png"
                alt="Logo"
              />
            </Link>
          </div>
         
        </div>

        {toggle ? (
          <AiOutlineClose
            onClick={() => setToggle(!toggle)}
            className="text-2xl text-[#fff] md:hidden"
            block
          />
        ) : (
          <AiOutlineMenu
            onClick={() => setToggle(!toggle)}
            className="text-2xl text-[#fff] md:hidden"
            block
          />
        )}

        {/* Responsive Menu */}

        <ul
          className={`fixed top-[80px] h-screen w-[100%] bg-[#231C42] duration-300 md:hidden ${
            toggle ? "left-[0]" : "left-[-100%]"
          }`}
        >
          <li className="px-6 py-3">
            <NavLink
              style={navLinkStyles}
              onClick={() => {
                setToggle(false);
              }}
              className="font-open text-[16px] tracking-[0.003px] text-[#fff]"
              to="/services"
            >
              Services
            </NavLink>
          </li>
          <li className="px-6 py-3">
            <NavLink
              style={navLinkStyles}
              onClick={() => {
                setToggle(false);
              }}
              className="font-open text-[16px] tracking-[0.003px] text-[#fff]"
              to="/about"
            >
              About Us
            </NavLink>
          </li>
          {/* <li className="px-6 py-3">
            <NavLink
              style={navLinkStyles}
              onClick={() => {
                setToggle(false);
              }}
              className="font-open text-[16px] tracking-[0.003px] text-[#fff]"
              to="/blog"
            >
              Our Blogs
            </NavLink>
          </li> */}
          <li className="px-6 py-3">
            <NavLink
              style={navLinkStyles}
              onClick={() => {
                setToggle(false);
              }}
              className="font-open text-[16px] tracking-[0.003px] text-[#fff]"
              to="/contact"
            >
              Contact Us
            </NavLink>
          </li>
          <li className="px-6 py-3">
            <NavLink
              style={navLinkStyles}
              onClick={() => {
                setToggle(false);
              }}
              className="font-open text-[16px] tracking-[0.003px] text-[#fff]"
              to="/faq"
            >
              FAQ’s
            </NavLink>
          </li>
          <li className="px-6 py-3">
            <NavLink
              style={navLinkStyles}
              onClick={() => {
                setToggle(false);
              }}
              className="font-open text-[16px] tracking-[0.003px] text-[#fff]"
              to="/pricing"
            >
              Pricing
            </NavLink>
          </li>

        
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
